<script setup lang="ts">
import type { HighlightCustomArea } from "@/models/Viewer";

defineProps<HighlightCustomArea>();
</script>
<template>
  <svg :width="page.width" :height="page.height" :viewBox="`0 0 ${page.width} ${page.height}`">
    <rect :="rectangle" :style="{ fill: fill ?? '#FFFF00', opacity }" />
  </svg>
</template>
